document.addEventListener('DOMContentLoaded', function() {
    var scrollUpBtn = document.querySelector('.scroll-up');

    scrollUpBtn.addEventListener('click', function() {
        smoothScrollToTop(500); // Czas animacji (ms)
    });

    function smoothScrollToTop(duration) {
        var startPosition = window.pageYOffset || document.documentElement.scrollTop;
        var startTime = performance.now();

        function scrollStep(timestamp) {
            var currentTime = timestamp - startTime;
            var scrollDistance = startPosition - currentTime / duration * startPosition;

            window.scrollTo(0, scrollDistance);

            if (currentTime < duration) {
                requestAnimationFrame(scrollStep);
            } else {
                window.scrollTo(0, 0);
            }
        }

        requestAnimationFrame(scrollStep);
    }
});
